import { TenantCustomerIndexSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Tenant-scoped customer index — one doc per customer who has paid at this
 * tenant at least once. Maintained server-side by `onTicketCollected`; this
 * repo is read-only from the dashboard (writes denied by firestore.rules).
 *
 *   tenants/{tid}/customers/{customerUid}
 *
 * Powers /customers search + detail panel. See TenantCustomerIndexSchema
 * for the projection rationale.
 */
export function customersRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/customers`,
    schema: TenantCustomerIndexSchema,
    name: `tenants/${tenantId}/customers`,
  });
}
